import styles from './index.module.scss';

interface LoadingProps {
  size?: 'default' | 'sm' | '2x' | '3x';
  dark?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({ size = 'default', dark = false }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const loadingClass = `${styles.loading} ${dark ? styles.laDark : ''} ${size !== 'default' ? styles[`la${size}`] : ''}`;

  return (
    <div className={loadingClass}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loading;
